<template>
    <div class="page-container">
        <van-nav-bar left-arrow :title="pageTitle" @click-left="goableBack()" :z-index="10"></van-nav-bar>
        <div class="webview-container">
            <iframe 
                ref="webviewFrame"
                :src="finalUrl" 
                style="width: 100%; height: 100%; border: none;"
                @load="onFrameLoad"
                :sandbox="sandboxAttr"
                :allow="allowAttr"
            ></iframe>
        </div>
    </div>
</template>

<script>
import { NavBar } from "vant";
import { getToken } from '@/utils/cookie';
import store from '@/store';

export default {
    components: {
        [NavBar.name]: NavBar,
    },

    data() {
        return {
            pageTitle: '',
            webUrl: '',
            finalUrl: '',
            sandboxAttr: '',
            allowAttr: ''
        };
    },

    created() {
        this.pageTitle = this.$route.query.title || '';
        this.webUrl = decodeURIComponent(this.$route.query.url || '');
        
        // 配置 iframe 属性和 URL
        this.configureIframe();
        
        // 添加 postMessage 监听
        window.addEventListener('message', this.handleMessage);
    },

    beforeDestroy() {
        // 移除监听
        window.removeEventListener('message', this.handleMessage);
    },

    methods: {
        configureIframe() {
            const token = getToken();
            const channelCode = store.getters.channel;
            const userInfo = store.state.userInfo;
            
            // 配置 sandbox 属性，允许 cookie 和脚本执行
            this.sandboxAttr = 'allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation';
            
            // 配置 allow 属性
            this.allowAttr = 'accelerometer; camera; encrypted-media; geolocation; gyroscope; microphone';
            
            // 如果有 token，将其添加到 URL 参数中
            if (token) {
                const url = new URL(this.webUrl, window.location.origin);
                
                // 添加认证参数到 URL
                url.searchParams.set('token', token);
                url.searchParams.set('Authorization', token);
                
                // 添加渠道参数
                if (channelCode) {
                    url.searchParams.set('chanlCode', channelCode.toUpperCase());
                }
                
                // 添加用户ID（从 URL 参数或 store 中获取）
                const userId = this.$route.query.userId || (userInfo && userInfo.custAccount && userInfo.custAccount.custId);
                if (userId) {
                    url.searchParams.set('x-affiliator-user-id', userId);
                }
                
                // 添加渠道代码（从 URL 参数获取）
                const affiliatorCode = this.$route.query['X-Affiliator-Code'] || this.$route.query.affiliatorCode;
                if (affiliatorCode) {
                    url.searchParams.set('x-affiliator-code', affiliatorCode);
                }
                
                this.finalUrl = url.toString();
            } else {
                this.finalUrl = this.webUrl;
            }
        },

        onFrameLoad() {
            // iframe 加载完成后，通过 postMessage 传递完整的认证信息
            try {
                const token = getToken();
                const channelCode = store.getters.channel;
                const userInfo = store.state.userInfo;
                
                // 获取当前域名下的所有 cookie
                const cookies = document.cookie;
                
                // 构建认证信息对象
                const authInfo = {
                    type: 'AUTH_INFO',
                    token: token,
                    Authorization: token,
                    chanlCode: channelCode ? channelCode.toUpperCase() : null,
                    cookies: cookies,
                    // 添加用户ID
                    userId: this.$route.query.userId || (userInfo && userInfo.custAccount && userInfo.custAccount.custId),
                    // 添加渠道代码
                    affiliatorCode: this.$route.query['X-Affiliator-Code'] || this.$route.query.affiliatorCode,
                    // 添加其他可能的认证信息
                    timestamp: Date.now()
                };
                
                console.log('向 iframe 发送认证信息:', authInfo);
                
                this.$refs.webviewFrame.contentWindow.postMessage(authInfo, '*');
            } catch (e) {
                console.error('向 iframe 发送消息失败:', e);
            }
        },

        handleMessage(event) {
            // 安全检查：验证消息来源（可选）
            // if (event.origin !== 'https://your-domain.com') return;
            
            const data = event.data;
            
            if (data && data.type) {
                switch (data.type) {
                    case 'NAVIGATE':
                        // 处理页面跳转
                        this.handleNavigate(data);
                        break;
                    case 'CLOSE':
                        // 关闭当前页面，返回上一页
                        this.goableBack();
                        break;
                    case 'RELOAD':
                        // 刷新页面
                        window.location.reload();
                        break;
                    case 'REQUEST_AUTH':
                        // iframe 请求认证信息
                        this.onFrameLoad();
                        break;
                    default:
                        console.log('未知消息类型:', data.type);
                }
            }
        },

        handleNavigate(data) {
            const url = data.url;
            if (!url) return;

            // 判断是外部链接还是内部路由
            if (url.startsWith('http://') || url.startsWith('https://')) {
                // 外部链接：直接跳转
                location.href = url;
            } else {
                // 内部路由：使用 vue-router 跳转
                try {
                    const parsedUrl = new URL(url, window.location.origin);
                    const path = parsedUrl.pathname;
                    const query = {};
                    
                    // 解析查询参数
                    parsedUrl.searchParams.forEach((value, key) => {
                        query[key] = value;
                    });
                    
                    this.$router.push({
                        path: path,
                        query: query
                    });
                } catch (e) {
                    // 如果解析失败，尝试直接使用 URL
                    this.$router.push(url);
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
.page-container {
    padding: 0;
    width: 100%;
    height: 100vh;
}

.webview-container {
    width: 100%;
    height: calc(100vh - 46px);
}
</style>
